import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

export type InputTypes = 'alpha' | 'numeric' | 'city' | 'alphaNumeric' | 'alphaNumericWithSpaceHyphen' | 'any';

@Directive({
  selector: '[polAdminMaskInput]'
})
export class MaskInputDirective {
  @Input() polAdminMaskInput: InputTypes;
  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event): void {
    this.onInputChange(event);
  }

  onInputChange(event): void {
    let regex;
    switch (this.polAdminMaskInput) {
      case 'alpha':
        regex = new RegExp(/[^a-z]/gi);
        break;
      case 'numeric':
        regex = new RegExp(/\D/g);
        break;
        /* 
        this numeric regex cannot use in reactiveForm input, because it retains the last digit user input in form eventhough it's invisible in textbox.
        Use "inputNumeric.directive.ts" which triggers the valueAccess in appropriate time.
        */
      case 'city':
        regex = new RegExp(/[^a-z'. ]/gi);
        break;
      case 'alphaNumeric':
        regex = new RegExp(/[^a-zA-Z0-9]/gi);
        break;
      case 'alphaNumericWithSpaceHyphen':
        regex = new RegExp(/[^a-z\d\-\s]+$/gi);
        break;
      case 'any':
        regex = '';
        break;
      default:
        return;
    }
    let newVal = event?.replace(regex, '');

    if (!newVal) {
      newVal = '';
    }

    this.ngControl.valueAccessor.writeValue(newVal);
  }
}
